export default __webpack_public_path__ + "static/media/DescribingPeople_09.04cd2c80.png";